// RTO city lookup — keyed by first 4 chars of plate (2-letter state + 2-digit district code)
// Gives district-level accuracy for free, with no API call.
// Fallback: STATE_CAPITALS used when the 4-char code isn't in this table.

export const STATE_CAPITALS = {
  AN:"Port Blair", AP:"Vijayawada", AR:"Itanagar",  AS:"Guwahati",
  BR:"Patna",      CG:"Raipur",     CH:"Chandigarh", DD:"Daman",
  DL:"Delhi",      DN:"Silvassa",   GA:"Panaji",     GJ:"Ahmedabad",
  HP:"Shimla",     HR:"Gurugram",   JH:"Ranchi",     JK:"Srinagar",
  KA:"Bengaluru",  KL:"Thiruvananthapuram", LA:"Leh", LD:"Kavaratti",
  MH:"Mumbai",     ML:"Shillong",   MN:"Imphal",     MP:"Bhopal",
  MZ:"Aizawl",     NL:"Kohima",     OD:"Bhubaneswar",OR:"Bhubaneswar",
  PB:"Ludhiana",   PY:"Pondicherry",RJ:"Jaipur",     SK:"Gangtok",
  TG:"Hyderabad",  TN:"Chennai",    TR:"Agartala",   TS:"Hyderabad",
  UK:"Dehradun",   UP:"Lucknow",    UT:"Dehradun",   WB:"Kolkata",
};

export const RTO_CITIES = {

  // ── Uttar Pradesh (UP) ────────────────────────────────────────────────────
  UP11:"Agra",         UP12:"Mathura",      UP13:"Etah",
  UP14:"Mainpuri",     UP15:"Aligarh",      UP16:"Bulandshahr",
  UP17:"Moradabad",    UP18:"Meerut",       UP19:"Hapur",
  UP20:"Ghaziabad",    UP21:"Noida",        UP22:"Hapur",
  UP23:"Shamli",       UP24:"Muzaffarnagar",UP25:"Saharanpur",
  UP26:"Baghpat",      UP27:"Badaun",       UP28:"Amroha",
  UP29:"Bijnor",       UP30:"Rampur",       UP31:"Bareilly",
  UP32:"Lakhimpur",    UP33:"Pilibhit",     UP34:"Shahjahanpur",
  UP35:"Etawah",       UP36:"Auraiya",      UP37:"Kannauj",
  UP38:"Farrukhabad",  UP39:"Mainpuri",     UP40:"Jhansi",
  UP41:"Lalitpur",     UP42:"Orai",         UP43:"Hamirpur",
  UP44:"Mahoba",       UP45:"Banda",        UP46:"Chitrakoot",
  UP47:"Kanpur",       UP48:"Kanpur",       UP49:"Unnao",
  UP50:"Lucknow",      UP51:"Manjhanpur",   UP52:"Fatehpur",
  UP53:"Lucknow",      UP54:"Raebareli",    UP55:"Sultanpur",
  UP56:"Sultanpur",    UP57:"Barabanki",    UP58:"Sitapur",
  UP59:"Hardoi",       UP60:"Ayodhya",      UP61:"Akbarpur",
  UP62:"Gonda",        UP63:"Balrampur",    UP64:"Bahraich",
  UP65:"Bhinga",       UP66:"Gorakhpur",    UP67:"Deoria",
  UP68:"Kushinagar",   UP69:"Maharajganj",  UP70:"Prayagraj",
  UP71:"Basti",        UP72:"Siddharthnagar",UP73:"Azamgarh",
  UP74:"Mau",          UP75:"Ballia",       UP76:"Varanasi",
  UP77:"Chandauli",    UP78:"Ghazipur",     UP79:"Jaunpur",
  UP80:"Mirzapur",     UP81:"Sonbhadra",    UP82:"Bhadohi",
  UP83:"Prayagraj",    UP84:"Pratapgarh",   UP85:"Lucknow",

  // ── Maharashtra (MH) ─────────────────────────────────────────────────────
  MH01:"Mumbai",  MH02:"Mumbai",  MH03:"Mumbai",  MH04:"Thane",
  MH05:"Kalyan",  MH06:"Navi Mumbai", MH07:"Mumbai", MH08:"Mumbai",
  MH09:"Nashik",  MH10:"Dhule",   MH11:"Jalgaon", MH12:"Pune",
  MH13:"Solapur", MH14:"Kolhapur",MH15:"Sangli",  MH16:"Satara",
  MH17:"Ratnagiri",MH18:"Oras",   MH19:"Ahmednagar",MH20:"Chhatrapati Sambhaji Nagar",
  MH21:"Jalna",   MH22:"Beed",    MH23:"Osmanabad",MH24:"Nanded",
  MH25:"Latur",   MH26:"Parbhani",MH27:"Hingoli", MH28:"Nagpur",
  MH29:"Wardha",  MH30:"Chandrapur",MH31:"Gadchiroli",MH32:"Yavatmal",
  MH33:"Amravati",MH34:"Akola",   MH35:"Washim",  MH36:"Buldhana",
  MH37:"Ahmednagar",MH38:"Alibag",MH40:"Mumbai",  MH43:"Palghar",
  MH44:"Nandurbar",MH46:"Pune",   MH47:"Pune",    MH48:"Pune",
  MH49:"Pune",    MH50:"Pune",

  // ── Tamil Nadu (TN) ──────────────────────────────────────────────────────
  TN01:"Chennai", TN02:"Chennai", TN03:"Chennai", TN04:"Chennai",
  TN05:"Kancheepuram",TN06:"Tiruvallur",TN07:"Vellore",TN08:"Dharmapuri",
  TN09:"Salem",   TN10:"Namakkal",TN11:"Erode",   TN12:"Coimbatore",
  TN13:"Ooty",    TN14:"Tiruppur",TN15:"Karur",   TN16:"Tiruchirappalli",
  TN17:"Perambalur",TN18:"Ariyalur",TN19:"Thanjavur",TN20:"Nagapattinam",
  TN21:"Tiruvarur",TN22:"Pudukkottai",TN23:"Madurai",TN24:"Dindigul",
  TN25:"Theni",   TN26:"Virudhunagar",TN27:"Ramanathapuram",TN28:"Thoothukudi",
  TN29:"Tirunelveli",TN30:"Nagercoil",TN31:"Cuddalore",TN32:"Villupuram",
  TN33:"Kallakurichi",TN34:"Krishnagiri",TN35:"Tirupattur",TN36:"Ranipet",
  TN37:"Chengalpattu",TN38:"Kancheepuram",TN39:"Tiruvannamalai",

  // ── Gujarat (GJ) ─────────────────────────────────────────────────────────
  GJ01:"Ahmedabad",GJ02:"Mehsana",GJ03:"Gandhinagar",GJ04:"Himmatnagar",
  GJ05:"Patan",   GJ06:"Palanpur",GJ07:"Rajkot",  GJ08:"Jamnagar",
  GJ09:"Junagadh",GJ10:"Amreli", GJ11:"Bhavnagar",GJ12:"Surendranagar",
  GJ13:"Surat",   GJ14:"Vadodara",GJ15:"Bharuch",  GJ16:"Anand",
  GJ17:"Nadiad",  GJ18:"Navsari", GJ19:"Valsad",   GJ20:"Ahwa",
  GJ21:"Rajpipla",GJ22:"Godhra",  GJ23:"Dahod",    GJ24:"Porbandar",
  GJ25:"Bhuj",    GJ26:"Morbi",   GJ27:"Botad",    GJ28:"Modasa",
  GJ29:"Lunawada",GJ30:"Dwarka",  GJ31:"Veraval",  GJ32:"Chhota Udaipur",

  // ── Karnataka (KA) ───────────────────────────────────────────────────────
  KA01:"Bengaluru",KA02:"Bengaluru",KA03:"Bengaluru",KA04:"Bengaluru",
  KA05:"Mysuru",  KA06:"Mandya",  KA07:"Hassan",   KA08:"Chikmagalur",
  KA09:"Tumakuru",KA10:"Chitradurga",KA11:"Davanagere",KA12:"Shivamogga",
  KA13:"Udupi",   KA14:"Mangaluru",KA15:"Karwar",  KA16:"Hubli",
  KA17:"Gadag",   KA18:"Haveri",  KA19:"Belagavi", KA20:"Vijayapura",
  KA21:"Bagalkot",KA22:"Kalaburagi",KA23:"Raichur", KA24:"Koppal",
  KA25:"Ballari", KA26:"Bidar",   KA27:"Yadgir",   KA28:"Chamarajanagar",
  KA29:"Madikeri",KA30:"Chikballapur",KA31:"Ramanagara",KA32:"Bengaluru",
  KA41:"Bengaluru",KA53:"Bengaluru",

  // ── Rajasthan (RJ) ───────────────────────────────────────────────────────
  RJ01:"Ajmer",   RJ02:"Alwar",   RJ03:"Banswara", RJ04:"Baran",
  RJ05:"Barmer",  RJ06:"Bharatpur",RJ07:"Bhilwara",RJ08:"Bikaner",
  RJ09:"Bundi",   RJ10:"Chittorgarh",RJ11:"Churu", RJ12:"Dausa",
  RJ13:"Dholpur", RJ14:"Dungarpur",RJ15:"Hanumangarh",RJ16:"Jaipur",
  RJ17:"Jaisalmer",RJ18:"Jalore", RJ19:"Jhalawar", RJ20:"Jhunjhunu",
  RJ21:"Jodhpur", RJ22:"Karauli", RJ23:"Kota",     RJ24:"Nagaur",
  RJ25:"Pali",    RJ26:"Rajsamand",RJ27:"Sawai Madhopur",RJ28:"Sikar",
  RJ29:"Sirohi",  RJ30:"Sri Ganganagar",RJ31:"Tonk",RJ32:"Udaipur",
  RJ33:"Pratapgarh",RJ34:"Jaipur",

  // ── West Bengal (WB) ─────────────────────────────────────────────────────
  WB01:"Kolkata", WB02:"Howrah",  WB03:"Chinsurah", WB04:"Barasat",
  WB05:"Baruipur",WB06:"Krishnanagar",WB07:"Berhampore",WB08:"Suri",
  WB09:"Burdwan", WB10:"Asansol", WB11:"Bankura",  WB12:"Purulia",
  WB13:"Midnapore",WB14:"Midnapore",WB15:"Jhargram",WB16:"Jalpaiguri",
  WB17:"Darjeeling",WB18:"Cooch Behar",WB19:"Malda",WB20:"Raiganj",
  WB21:"Balurghat",WB22:"Siliguri",WB23:"Alipurduar",WB24:"Alipurduar",
  WB25:"Kalimpong",

  // ── Madhya Pradesh (MP) ──────────────────────────────────────────────────
  MP01:"Bhopal",  MP02:"Sehore",  MP03:"Raisen",   MP04:"Vidisha",
  MP05:"Rajgarh", MP06:"Gwalior", MP07:"Shivpuri",  MP08:"Guna",
  MP09:"Datia",   MP10:"Morena",  MP11:"Bhind",    MP12:"Sheopur",
  MP13:"Indore",  MP14:"Dhar",    MP15:"Jhabua",   MP16:"Alirajpur",
  MP17:"Barwani", MP18:"Khargone",MP19:"Khandwa",  MP20:"Burhanpur",
  MP21:"Ujjain",  MP22:"Dewas",   MP23:"Shajapur", MP24:"Ratlam",
  MP25:"Mandsaur",MP26:"Neemuch", MP27:"Jabalpur", MP28:"Narsinghpur",
  MP29:"Seoni",   MP30:"Chhindwara",MP31:"Mandla",  MP32:"Dindori",
  MP33:"Balaghat",MP34:"Katni",   MP35:"Sagar",    MP36:"Damoh",
  MP37:"Panna",   MP38:"Chhatarpur",MP39:"Tikamgarh",MP40:"Rewa",
  MP41:"Satna",   MP42:"Sidhi",   MP43:"Singrauli", MP44:"Shahdol",
  MP45:"Umaria",  MP46:"Anuppur", MP47:"Narmadapuram",MP48:"Harda",
  MP49:"Betul",

  // ── Haryana (HR) ─────────────────────────────────────────────────────────
  HR01:"Ambala",  HR02:"Ambala",  HR03:"Bhiwani",  HR04:"Faridabad",
  HR05:"Gurugram",HR06:"Hisar",   HR07:"Jhajjar",  HR08:"Jind",
  HR09:"Kaithal", HR10:"Karnal",  HR11:"Kurukshetra",HR12:"Narnaul",
  HR13:"Nuh",     HR14:"Palwal",  HR15:"Panchkula",HR16:"Panipat",
  HR17:"Rewari",  HR18:"Rohtak",  HR19:"Sirsa",    HR20:"Sonipat",
  HR21:"Yamuna Nagar",HR22:"Fatehabad",HR23:"Charkhi Dadri",HR26:"Gurugram",

  // ── Punjab (PB) ──────────────────────────────────────────────────────────
  PB01:"Amritsar",PB02:"Kapurthala",PB03:"Gurdaspur",PB04:"Hoshiarpur",
  PB05:"Jalandhar",PB06:"Nawanshahr",PB07:"Rupnagar",PB08:"Fatehgarh Sahib",
  PB09:"Ludhiana",PB10:"Moga",    PB11:"Firozpur", PB12:"Faridkot",
  PB13:"Muktsar", PB14:"Bathinda",PB15:"Mansa",    PB16:"Sangrur",
  PB17:"Patiala", PB18:"Mohali",  PB19:"Barnala",  PB20:"Malerkotla",
  PB21:"Pathankot",PB65:"Chandigarh",

  // ── Bihar (BR) ───────────────────────────────────────────────────────────
  BR01:"Patna",    BR02:"Patna",    BR03:"Biharsharif",BR04:"Gaya",
  BR05:"Nawada",   BR06:"Aurangabad",BR07:"Arwal",   BR08:"Jehanabad",
  BR09:"Arrah",    BR10:"Buxar",    BR11:"Bhabua",   BR12:"Sasaram",
  BR13:"Chapra",   BR14:"Siwan",    BR15:"Gopalganj",BR16:"Bettiah",
  BR17:"Motihari", BR18:"Muzaffarpur",BR19:"Sitamarhi",BR20:"Sheohar",
  BR21:"Hajipur",  BR22:"Samastipur",BR23:"Darbhanga",BR24:"Madhubani",
  BR25:"Supaul",   BR26:"Saharsa",  BR27:"Madhepura",BR28:"Purnea",
  BR29:"Kishanganj",BR30:"Katihar", BR31:"Araria",   BR32:"Bhagalpur",
  BR33:"Banka",    BR34:"Munger",   BR35:"Begusarai",BR36:"Khagaria",
  BR37:"Lakhisarai",BR38:"Sheikhpura",BR39:"Jamui",  BR40:"Jehanabad",

  // ── Andhra Pradesh (AP) ──────────────────────────────────────────────────
  AP01:"Srikakulam",AP02:"Vizianagaram",AP03:"Visakhapatnam",AP04:"Kakinada",
  AP05:"Eluru",   AP06:"Vijayawada", AP07:"Guntur",   AP08:"Ongole",
  AP09:"Nellore", AP10:"Chittoor",   AP11:"Kadapa",   AP12:"Kurnool",
  AP13:"Anantapur",

  // ── Telangana (TS/TG) ────────────────────────────────────────────────────
  TS01:"Hyderabad",TS02:"Hyderabad",TS03:"Hyderabad",TS04:"Hyderabad",
  TS05:"Hyderabad",TS06:"Hyderabad",TS07:"Hyderabad",TS08:"Hyderabad",
  TS09:"Rangareddy",TS10:"Medchal",TS11:"Sangareddy",TS12:"Medak",
  TS13:"Nizamabad",TS14:"Nizamabad",TS15:"Kamareddy",TS16:"Jagityal",
  TS17:"Karimnagar",TS18:"Peddapalli",TS19:"Jagityal",TS20:"Warangal",
  TS21:"Warangal",TS22:"Jangaon",TS23:"Hanamkonda",TS24:"Mahabubabad",
  TS25:"Khammam",TS26:"Kothagudem",TS27:"Nalgonda",
  TS28:"Suryapet",TS29:"Bhongir",TS30:"Mahbubnagar",TS31:"Narayanpet",
  TS32:"Wanaparthy",TS33:"Gadwal",TS34:"Nagarkurnool",TS35:"Nalgonda",
  TG01:"Hyderabad",TG09:"Rangareddy",TG10:"Medchal",

  // ── Kerala (KL) ──────────────────────────────────────────────────────────
  KL01:"Thiruvananthapuram",KL02:"Kollam",KL03:"Pathanamthitta",KL04:"Alappuzha",
  KL05:"Kottayam",KL06:"Idukki",KL07:"Ernakulam",KL08:"Thrissur",
  KL09:"Palakkad",KL10:"Malappuram",KL11:"Kozhikode",KL12:"Kalpetta",
  KL13:"Kannur",KL14:"Kasaragod",KL15:"Ernakulam",KL58:"Ernakulam",
  KL59:"Ernakulam",KL60:"Thiruvananthapuram",

  // ── Odisha (OD/OR) ───────────────────────────────────────────────────────
  OD01:"Bhubaneswar",OD02:"Cuttack",OD03:"Puri",OD04:"Khordha",
  OD05:"Balasore",OD06:"Baripada",OD07:"Keonjhar",OD08:"Jajpur",
  OD09:"Jagatsinghpur",OD10:"Kendrapara",OD11:"Bhadrak",OD12:"Balangir",
  OD13:"Sambalpur",OD14:"Bargarh",OD15:"Jharsuguda",OD16:"Sundargarh",
  OD17:"Sonepur",OD18:"Nuapada",OD19:"Bhawanipatna",OD20:"Nabarangpur",
  OD21:"Rayagada",OD22:"Koraput",OD23:"Malkangiri",OD24:"Paralakhemundi",
  OD25:"Chatrapur",OD26:"Phulbani",OD27:"Deogarh",OD28:"Angul",
  OD29:"Dhenkanal",OD30:"Nayagarh",

  // ── Uttarakhand (UK) ─────────────────────────────────────────────────────
  UK01:"Dehradun",UK02:"Haridwar",UK03:"Pauri",UK04:"New Tehri",
  UK05:"Uttarkashi",UK06:"Gopeshwar",UK07:"Rudraprayag",UK08:"Bageshwar",
  UK09:"Almora",UK10:"Champawat",UK11:"Pithoragarh",UK12:"Nainital",
  UK13:"Rudrapur",UK14:"Haridwar",UK50:"Dehradun",

  // ── Himachal Pradesh (HP) ────────────────────────────────────────────────
  HP01:"Shimla",HP02:"Solan",HP03:"Nahan",HP04:"Bilaspur",
  HP05:"Hamirpur",HP06:"Una",HP07:"Dharamshala",HP08:"Kullu",
  HP09:"Keylong",HP10:"Reckong Peo",HP11:"Chamba",HP12:"Mandi",
  HP13:"Kangra",HP14:"Kangra",HP15:"Shimla",HP16:"Baddi",

  // ── Jharkhand (JH) ───────────────────────────────────────────────────────
  JH01:"Ranchi",JH02:"Jamshedpur",JH03:"Chaibasa",
  JH04:"Saraikela",JH05:"Dhanbad",JH06:"Bokaro",JH07:"Chatra",
  JH08:"Hazaribagh",JH09:"Koderma",JH10:"Giridih",JH11:"Deoghar",
  JH12:"Dumka",JH13:"Jamtara",JH14:"Sahebganj",JH15:"Pakur",
  JH16:"Godda",JH17:"Garhwa",JH18:"Daltonganj",JH19:"Latehar",
  JH20:"Lohardaga",JH21:"Gumla",JH22:"Simdega",JH23:"Khunti",
  JH24:"Ramgarh",

  // ── Chhattisgarh (CG) ────────────────────────────────────────────────────
  CG01:"Raipur",CG02:"Durg",CG03:"Rajnandgaon",CG04:"Kawardha",
  CG05:"Bilaspur",CG06:"Korba",CG07:"Janjgir",CG08:"Raigarh",
  CG09:"Jashpurnagar",CG10:"Ambikapur",CG11:"Baikunthpur",CG12:"Jagdalpur",
  CG13:"Kanker",CG14:"Kondagaon",CG15:"Narayanpur",CG16:"Bijapur",
  CG17:"Dantewada",CG18:"Sukma",CG19:"Mahasamund",CG20:"Gariaband",
  CG21:"Baloda Bazar",CG22:"Balod",CG23:"Bemetara",CG24:"Mungeli",
  CG25:"Gaurela",CG26:"Sarangarh",CG27:"Manendragarh",

  // ── Assam (AS) ───────────────────────────────────────────────────────────
  AS01:"Guwahati",AS02:"Guwahati",AS03:"Guwahati",AS04:"Nalbari",
  AS05:"Barpeta",AS06:"Bongaigaon",AS07:"Kokrajhar",AS08:"Dhubri",
  AS09:"Goalpara",AS10:"Dibrugarh",AS11:"Tinsukia",AS12:"Sibsagar",
  AS13:"Jorhat",AS14:"Golaghat",AS15:"Nagaon",AS16:"Morigaon",
  AS17:"Morigaon",AS18:"Diphu",AS19:"Haflong",
  AS20:"Silchar",AS21:"Hailakandi",AS22:"Karimganj",
  AS23:"Dhemaji",AS24:"Lakhimpur",AS25:"Tezpur",
  AS26:"Biswanath",AS27:"Hojai",

  // ── Goa (GA) ─────────────────────────────────────────────────────────────
  GA01:"Panaji",GA02:"Panaji",GA03:"Margao",GA04:"Mapusa",GA05:"Vasco",
  GA06:"Panaji",

  // ── Delhi (DL) ───────────────────────────────────────────────────────────
  // Delhi uses alphanumeric district codes (DL4C, DL9C etc.) — map all to Delhi
  // Handled by STATE_CAPITALS fallback

  // ── Jammu & Kashmir (JK) ─────────────────────────────────────────────────
  JK01:"Jammu",JK02:"Udhampur",JK03:"Kathua",JK04:"Doda",JK05:"Ramban",
  JK06:"Reasi",JK07:"Rajouri",JK08:"Poonch",JK09:"Srinagar",JK10:"Budgam",
  JK11:"Anantnag",JK12:"Kulgam",JK13:"Pulwama",JK14:"Shopian",
  JK15:"Baramulla",JK16:"Bandipora",JK17:"Kupwara",JK18:"Ganderbal",
  JK19:"Samba",JK20:"Kishtwar",

  // ── Chandigarh (CH) ──────────────────────────────────────────────────────
  CH01:"Chandigarh",CH02:"Chandigarh",CH03:"Chandigarh",CH04:"Chandigarh",

};

// Look up the city for a vehicle plate number.
// Tries 4-char RTO code first (district level), then 2-char state code (state capital fallback).
export function getCityFromPlate(plateNumber) {
  const clean = plateNumber.replace(/[\s-]/g, "").toUpperCase();
  // Extract state (2 letters) + district (next 2 chars, usually digits)
  const state = clean.slice(0, 2);
  const dist  = clean.slice(2, 4);
  const code4 = state + dist;

  // Try district-level first
  if (/^\d{2}$/.test(dist) && RTO_CITIES[code4]) return RTO_CITIES[code4];

  // Fall back to state capital
  return STATE_CAPITALS[state] || null;
}
